import React from 'react';

function LeafIcon({ width = 24, height = 24, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 24 24">
      <g>
        <path d="M18,7 C7.2,9.4 4.68,16.804 2.184,23.008 L4.452,23.8 L5.592,21.04 C6.168,21.244 6.768,21.4 7.2,21.4 C20.4,21.4 24,1 24,1 C22.8,3.4 14.4,3.7 8.4,4.9 C2.4,6.1 0,11.2 0,13.6 C0,16 2.1,18.1 2.1,18.1 C6,7 18,7 18,7 Z" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default LeafIcon;
